import { wanModels, wanVersions } from './catalog';
import { generatorCategories, wanModelLabel, type GeneratorCategoryId } from './categories';

export const wanVersionSlug = (version: string) => version.replace('.', '-');
export const wanPageVersions = wanVersions.filter(version => version !== '3.0-prime');
export const wanFamilyVersion = (version: string) => version === '3.0-prime' ? '3.0' : version;
export const wanVersionHref = (version: string) => `/wan/${wanVersionSlug(wanFamilyVersion(version))}`;
export const wanVersionName = (version: string) => `Wan ${version.replace('-prime', ' Prime')}`;
export const parseWanVersion = (slug: string) => wanVersions.find(version => slug === version || slug === wanVersionSlug(version));
export const versionModels = (version: string) => wanModels.filter(model => model.version === version || version === '3.0' && model.version === '3.0-prime');
export const versionCategories = (version: string) => generatorCategories.filter(category =>
  versionModels(version).some(model => (category.operations as readonly string[]).includes(model.operation)));

export function resolveVersionModel(version: string, requested?: string, categoryId?: GeneratorCategoryId) {
  const models = versionModels(version);
  const category = generatorCategories.find(item => item.id === categoryId);
  const options = category ? models.filter(model => (category.operations as readonly string[]).includes(model.operation)) : models;
  return options.find(model => model.key === requested)
    || options.find(model => model.operation === 'image-to-video')
    || options.find(model => model.operation === 'image-edit')
    || options.find(model => model.operation === 'image-edit-pro')
    || options.find(model => model.operation === 'text-to-video')
    || options.find(model => !/-(fast|flash|pro)$/.test(model.operation))
    || options[0];
}

export function versionModelLabels(version: string) {
  return [...new Set(versionModels(version).map(wanModelLabel))];
}
